import swal from "sweetalert";
import useUser from "../../../../core/hooks/use-user";
import Datatable from "../../../../core/ui/components/Datatable";
import { sweetAl, toast } from "../../../../core/helpers/message-helper";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import {
    aceptarHoraExtra,
    rechazarHoraExtra,
} from "../../services/gerente-service";

const Gerente = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();

    let tableButtons = [];

    if (userCan("nominaAceptarHorasExtras")) {
        tableButtons.push({
            titleAttr: "Aceptar horas",
            text: '<i class="fas fa-check"></i>',
            className: "btn btn-sm btn-secondary",
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea aceptar estas horas extras?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        aceptar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se han aceptado las horas extras");
                        break;
                    case "aceptar": {
                        const resp = await aceptarHoraExtra(data);

                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al aceptar las horas extras"
                            );
                        }

                        sweetAl.success("Las horas extras fueron aceptadas");
                        dt.ajax.reload();
                        break;
                    }
                }
            },
        });
    }

    if (userCan("nominaRechazarHorasExtras")) {
        tableButtons.push({
            titleAttr: "Rechazar horas",
            text: '<i class="fas fa-times"></i>',
            className: "btn btn-sm btn-danger",
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea rechazar estas horas extras?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        aceptar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se han rechazado las horas extras");
                        break;
                    case "aceptar": {
                        const resp = await rechazarHoraExtra(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al rechazar las horas extras"
                            );
                        }

                        sweetAl.success("Las horas extras fueron rechazadas");
                        dt.ajax.reload();
                        break;
                    }
                }
            },
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "horas-extras-gerencia",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaGerente",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/turnos/horasExtras/gerente`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listdo de horas extras"
                );
            },
        },
        columns: [
            { data: "nombres_persona" },
            { data: "nombre" },
            { data: "fecha_envio_gerencia" },
            { data: "total_horas_extras_diurnas" },
            { data: "total_horas_extras_nocturnas" },
            { data: "total_horas_extras_diurnas_festivas" },
            { data: "total_horas_extras_nocturnas_festivas" },
            { data: "observacion_envio_gerencia" },
            { data: "total_horas" },
            { data: "sede_has_area_id", visible: false },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    NÓMINA / Aprovación De Horas Extras
                </div>
            </div>
            <Datatable options={dtOptions}>
                <table className="w-100 table table-hover" id="tablaGerente">
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">
                                Responsable
                            </th>
                            <th className="text-center text-white">Area</th>
                            <th className="text-center text-white">
                                Fecha de envio
                            </th>
                            <th className="text-center text-white">Diurnas</th>
                            <th className="text-center text-white">
                                Nocturnas
                            </th>
                            <th className="text-center text-white">
                                Diurnas Festivas
                            </th>
                            <th className="text-center text-white">
                                Nocturnas Festivas
                            </th>
                            <th className="text-center text-white">
                                Observación
                            </th>
                            <th className="text-center text-white">
                                Cantidad Total
                            </th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
        </ContentWrapper>
    );
};

export default Gerente;
